import React from 'react';
import { Helmet } from 'react-helmet-async';

/* =====================================================================
   Seo — her sayfada route'a özel meta üretir.
   react-helmet-async + react-snap ile prerender'da <head>'e basılır.

   Kullanım (her page bileşeninin en üstünde):
     <Seo
       title="Fiyatlar — Tilki Otomasyon"
       description="Aylık ve yıllık planlar; kurulum ücreti yok."
       path="/fiyatlar"
       jsonLd={faqJsonLd}   // opsiyonel: yapısal veri objesi/array
     />
   ===================================================================== */

const SITE = 'https://tilkiotomasyon.com';
// Repoda mevcut: public/img/tilki_og_image.jpg
// NOT: mevcut dosya 467×222 — büyük kart için küçük. 1200×630 yeni sürümle
// değiştirmen önerilir (aynı dosya adını koru, kod değişmesin).
const DEFAULT_OG = `${SITE}/img/tilki_og_image.jpg`;

export default function Seo({
  title,
  description,
  path = '/',
  image = DEFAULT_OG,
  noindex = false,
  jsonLd,
  type = 'website',
  publishedTime,
  modifiedTime,
}) {
  const url = `${SITE}${path}`;
  const fullTitle = title || 'Tilki Otomasyon — Restoran & Kafe Yönetim Platformu';

  return (
    <Helmet prioritizeSeoTags>
      <html lang="tr" />
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Tilki Otomasyon" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="tr_TR" />

      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {/* Yapısal veri (JSON-LD) */}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
